// Target blank
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    }
}

// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first-child').show();

// Click function
$('#tabs-nav li').click(function () {
  let temp = $(this);
  let wrapper = temp.closest('.shopify-section');
  let wid = $(wrapper).attr('id');
  let ts = null;
  ts = `#${wid} #tabs-nav li`;
  
  $(ts).removeClass('active');
  $(this).addClass('active');
    
  ts = `#${wid} .tab-content`;
  $(ts).hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
  ``
});


// Testimonial
$('.testimonial').owlCarousel({
    nav: true,
    items: 1,
    margin: 30,
    dots: false,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/0036/2905/6098/files/caret-left.svg'>","<img src='https://cdn.shopify.com/s/files/1/0036/2905/6098/files/caret-right.svg'>"]
})

// Logos
$('.logos').owlCarousel({
    autoplay: true,
    loop: true,
    nav: false,
    dots: false,
    responsive:{
        0:{
            items: 2
        },
        600:{
            items: 3
        },
        768:{
            items: 3
        },
        1000:{
            items: 5
        }
    }
})

// Hotspot
$('.hotspot').owlCarousel({
    nav: true,
    items: 1,
    dots: false,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/0036/2905/6098/files/caret-circle-left.svg'>","<img src='https://cdn.shopify.com/s/files/1/0036/2905/6098/files/caret-circle-right.svg'>"]
})

// Hotspot Click
const selectHotspot = (e) => {
    const clickedHotspot = e.target.parentElement;
    const container = clickedHotspot.parentElement;
    
    // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
    const hotspots = container.querySelectorAll(".lg-hotspot"); 
    hotspots.forEach(hotspot => {
      if (hotspot === clickedHotspot) {
        hotspot.classList.toggle("lg-hotspot--selected");
      } else {
        hotspot.classList.remove("lg-hotspot--selected");
      }
    });
  }
  
  (() => {
    const buttons = document.querySelectorAll(".lg-hotspot__button");
    buttons.forEach(button => {
      button.addEventListener("click", selectHotspot);
    });
  })();
    